var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsListMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 5.4H0V24.3C0 25.785 1.215 27 2.7 27H21.6V24.3H2.7V5.4ZM24.3 0H8.1C6.615 0 5.4 1.215 5.4 2.7V18.9C5.4 20.385 6.615 21.6 8.1 21.6H24.3C25.785 21.6 27 20.385 27 18.9V2.7C27 1.215 25.785 0 24.3 0ZM24.3 18.9H8.1V2.7H24.3V18.9ZM10.8 9.45H21.6V12.15H10.8V9.45ZM10.8 13.5H16.2V16.2H10.8V13.5ZM10.8 5.4H21.6V8.1H10.8V5.4Z",
    fill: "#0C7488"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsListMenuIcon);
export default __webpack_public_path__ + "static/media/documents-list-menu-icon.cc284d77ee6916dd0efeeefa1ec0e09c.svg";
export { ForwardRef as ReactComponent };